// need to make this all shared between guild/char not 2 identical
import * as _ from 'lodash';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TGuildRecruitmentPageState } from '../libs/store';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { stripPathLocale } from '../../../../../shared/common/localeShared';

const getInitialState = (): TGuildRecruitmentPageState => ({
  currentEntityId: -1,
  loaded: false,
  loading: false,
  error: false,
  profiles: [],
  message: '',
  applicationModalOpen: false,
  sourceProfileId: -1,
  targetProfileId: -1,
  errorMessage: '',
  application: {
    loading: false,
    loaded: false,
    error: false,
    threadId: -1
  }
});

const LOAD_GUILD_RECRUITMENT_PROFILE = 'GUILD/RECRUITMENT/LOAD_PROFILES';
const LOAD_GUILD_RECRUITMENT_PROFILE_SUCCESS = 'GUILD/RECRUITMENT/LOAD_PROFILES_SUCCESS';
const LOAD_GUILD_RECRUITMENT_PROFILE_FAIL = 'GUILD/RECRUITMENT/LOAD_PROFILES_FAIL';

const loadGuildRecruitmentProfiles = () => ({
  type: LOAD_GUILD_RECRUITMENT_PROFILE,
  // reset profiles state, otherwise we'll end up trying to format profiles that
  // aren't relevant and blowing up.
  payload: { loading: true, profiles: [] }
});
const loadGuildRecruitmentProfileSuccess = (profiles: any) => ({
  type: LOAD_GUILD_RECRUITMENT_PROFILE_SUCCESS,
  payload: { profiles, loaded: true, loading: false }
});
const loadGuildRecruitmentProfileFail = () => ({
  type: LOAD_GUILD_RECRUITMENT_PROFILE_FAIL,
  payload: { error: true, loaded: true }
});

const REQUEST_APPLICATION = 'GUILD/RECRUITMENT/REQ_APPLICATION';
const REQUEST_APPLICATION_SUCCESS = 'GUILD/RECRUITMENT/REQUEST_APPLICATION_SUCCESS';
const REQUEST_APPLICATION_FAIL = 'GUILD/RECRUITMENT/REQUEST_APPLICATION_FAIL';
const requestApplication = (targetProfileId: number) => ({
  type: REQUEST_APPLICATION,
  payload: {
    application: {
      loading: true,
      loaded: false,
      error: false
    }
  }
});

const requestApplicationSuccess = (threadId: number) => ({
  type: REQUEST_APPLICATION_SUCCESS,
  payload: {
    application: {
      threadId,
      loading: false,
      loaded: true,
      error: false
    }
  }
});
const requestApplicationFail = (errorMessage?: string) => ({
  type: REQUEST_APPLICATION_FAIL,
  payload: {
    errorMessage,
    application: {
      loading: false,
      loaded: true,
      error: true
    }
  }
});

const SET_APPLICATION_MSG = 'GUILD/RECRUITMENT/SET_APPLICATION_MSG';
const SET_SOURCE_PROFILE = 'GUILD/RECRUITMENT/SET_SOURCE_PROFILE';
const setApplicationMessage = (message: string) => ({
  type: SET_APPLICATION_MSG,
  payload: { message }
});
const setSourceProfile = (sourceProfileId: number) => ({
  type: SET_SOURCE_PROFILE,
  payload: { sourceProfileId }
});

const SET_TARGET_PROFILE_ID = 'CHARACTER/RECRUITMENT/SET_TARGET_PROFILE_ID';
const setTarget = (targetProfileId: number) => ({
  type: SET_TARGET_PROFILE_ID,
  payload: {
    targetProfileId
  }
});

// identical to character, maybe the shared/recruitment folder needs duck so dont
// need to repeat this
const TOGGLE_APPLY_MODAL_VISIBILITY = 'CHARACTER/RECRUITMENT/TOGGLE_APP_MODAL';
const toggleApplyModal = () => ({ type: TOGGLE_APPLY_MODAL_VISIBILITY });

function guildRecruitmentPageReducer(
  // state: TGuildRecruitmentPageState = initialState, todo
  state: any = getInitialState(),
  action: TAction<any>
): TGuildRecruitmentPageState {
  switch (action.type) {
    case REQUEST_APPLICATION:
    case REQUEST_APPLICATION_SUCCESS:
    case REQUEST_APPLICATION_FAIL:
    case SET_APPLICATION_MSG:
    case SET_SOURCE_PROFILE:
    case SET_TARGET_PROFILE_ID:
    case LOAD_GUILD_RECRUITMENT_PROFILE:
    case LOAD_GUILD_RECRUITMENT_PROFILE_SUCCESS:
    case LOAD_GUILD_RECRUITMENT_PROFILE_FAIL:
      return { ...state, ...action.payload };
    case TOGGLE_APPLY_MODAL_VISIBILITY: {
      const { applicationModalOpen } = state;
      if (applicationModalOpen) {
        return {
          ...state,
          ..._.pick(getInitialState(), [
            'targetProfileId',
            'sourceProfileId',
            'message',
            'errorMessage',
            'application'
          ]),
          applicationModalOpen: false
        };
      }
      return { ...state, applicationModalOpen: true };
    }
    case LOCATION_CHANGE: {
      const location = stripPathLocale(action.payload.location.pathname);
      // only clear state if we navigate away from guild route
      if (!location.startsWith('/guilds/')) {
        return getInitialState();
      }
      return state;
    }
    default:
      return state;
  }
}

export const actions = {
  loadGuildRecruitmentProfiles,
  loadGuildRecruitmentProfileSuccess,
  loadGuildRecruitmentProfileFail,

  requestApplication,
  requestApplicationSuccess,
  requestApplicationFail,

  setApplicationMessage,
  setSourceProfile,

  toggleApplyModal,
  setTarget
};

export const actionTypes = {
  LOAD_GUILD_RECRUITMENT_PROFILE,
  REQUEST_APPLICATION
};

export default guildRecruitmentPageReducer;
